/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
 * @description It converts a given array of object into 2 separate classified arrays for toast and seven shifts configured restaurants
 * @param data
 * @returns {{toastConfiguredRestaurants: Array, sevenShiftConfiguredRestaurants: Array}}
 */

export const bifurcateRestaurantData = (data) => {
  const toastConfiguredRestaurants = [];
  const sevenShiftConfiguredRestaurants = [];

  data?.forEach(({ restaurant, toast_configured, seven_shifts_configured }) => {
    if (!toast_configured && !seven_shifts_configured) {
      return;
    }

    if (toast_configured) {
      toastConfiguredRestaurants.push({ id: restaurant.id, name: restaurant.name, provider: 'toast' });
    }

    if (seven_shifts_configured) {
      sevenShiftConfiguredRestaurants.push({ id: restaurant.id, name: restaurant.name, provider: 'seven_shifts' });
    }
  });

  return { toastConfiguredRestaurants, sevenShiftConfiguredRestaurants };
};

/**
 * @description It checks from restaurant data whether atleast one restaurant has configuration for toast or seven shifts
 * @param data
 * @returns {Array}
 */

export const hasAnyConfiguredSource = (data) => {
  return data?.some(({ toast_configured, seven_shifts_configured }) =>
    toast_configured || seven_shifts_configured
  ) || false
}
